import React from "react";
import "./content-page.css";

const SideNav = ({ label, heading, items, activeId, onSelect }) => (
  <nav className="side-nav" aria-label={label}>
    {heading && items.length > 0 && (
      <p className="side-nav__heading">{heading}</p>
    )}
    {items.map((item) => {
      const Icon = item.icon;
      const active = activeId === item.id;
      return (
        <a
          key={item.id}
          href={`#${item.id}`}
          className={`side-nav__link${active ? " is-active" : ""}`}
          aria-current={active ? "location" : undefined}
          onClick={(event) => onSelect(event, item.id)}
        >
          {Icon && <Icon className="side-nav__icon" aria-hidden="true" />}
          <span className="side-nav__title">{item.title}</span>
          {item.count !== undefined && (
            <span className="side-nav__count">{item.count}</span>
          )}
        </a>
      );
    })}
  </nav>
);

export default SideNav;
